<template>
	<div>
		<div class="search-wrapper">
			<div style="display:inline-block">
				<!-- <span v-if="allPermission"> -->
					<span>归属团队：</span>
					<Select v-model="search.filiale" style="width: 120px;margin-right:20px;">
						<Option v-for="depart in areaArr" :key="depart.id" :value="depart['name']">{{depart['name']}}</Option>
					</Select>
					<span>客户人员：</span>
					<Input v-model="search.am" style="width:150px;margin-right:20px;"></Input>
				<!-- </span> -->
				<span>单位名称：</span>
				<Input v-model="search.clientNmae" style="width:150px;margin-right:20px;"></Input>
				<span>拜访日期：</span>
				<DatePicker type="date" style="width: 120px" v-model="search.startTime"></DatePicker>
				<span style="margin:0 5px">至</span>
				<DatePicker type="date" style="width: 120px" v-model="search.endTime"></DatePicker>
			</div>
			<br>
			<Button type="primary" @click="searchResult" style="margin:10px 5px 0 0">搜索</Button>
			<Button type="primary" @click="addVisitList(empData)" style="margin-top:10px;">添加客户拜访记录</Button>
		</div>
		<Table :columns="columns" :data="purchaserVisitListData" style="min-width:1000px;"></Table>
		<Page :total="pageTotal" :current="pageNum" :page-size="pageSize" show-elevator show-total style="margin-top:5px;" @on-change="pageChange"></Page>
		<Modal v-model="addVisitListVisible" width="950" :title="title">
			<visitListCard v-on:ok="addOK" :curVisitListData="curVisitListData" :addStatus="addStatus" :editPermission="editPermission"></visitListCard>
			<div slot="footer"></div>
		</Modal>
	</div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import visitListCard from '@/components/visitListCard.vue'
import requestUrls from '@/lib/eRequestUrls'
import { formatDate } from '@/lib/tool'
import ajax from '@/lib/ajax'

export default {
	name: 'purchaserVisitListTable',
	components: {
		visitListCard
	},
	data() {
		return {
			columns: [
				{
					title: '分公司',
					key: 'filiale',
					width: 80,
				}, {
					title: '客户人员',
					key: 'am',
					width: 90,
				}, {
					title: '客户名称',
					key: 'clientNmae',
				}, {
					title: '是否为新客户',
					key: 'isNewClient',
					width: 110,
				}, {
					title: '跟进途径',
					key: 'followApproach',
					width: 90,
				}, {
					title: '拜访结果',
					key: 'visitResult',
				}, {
					title: '拜访时间',
					key: 'visitDate',
					width: 100,
				}, {
					title: '操作',
					width: 120,
					render: (h, params) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'primary',
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.viewVisitList(params.row)
									}
								}
							}, '查看信息')
						])
					}
				}],
			pageNum: 1,
			pageTotal: 0,
			pageSize: 10,
			purchaserVisitListData: [], //存放 table 的数据
			curVisitListData: {}, // 表示当前 行 的数据
			addVisitListVisible: false, // 添加 查看 Modal 的隐藏与否
			title: '', // modal 的title信息
			empData: {
				"客户名称": "",
				"客户经理": "",
				"分公司": "",
				"跟进途径": "",
				"地址": "",
				"拜访结果": "",
				"拜访时间": "",
				"是否为新客户": "",
				"名片图片地址": "",
				"名片": ""
			}, // 
			addStatus: '', //通过 add 参数的值来判断弹窗visitListCard 是查看拜访信息还是添加拜访信息
			search: {
				filiale: '',
				am: '',
				clientNmae: '',
				visitDate: '',
				startTime: '',
				endTime: ''
			},
			areaArr: [],
			areaPermission: ''
		}
	},
	async created() {
		if (!this.$store.state.session.user) {
			await this.$store.dispatch({
				type: 'session/init'
			})
		}
		this.empData.客户经理 = this.$store.state.session.user.name;
		let areaRep = await ajax.get(requestUrls.CLDistrict.GetList)
		this.areaArr = []
		this.areaPermission = ''
    if (areaRep.data.success && areaRep.data.result.items.length > 0) {
			this.areaArr = areaRep.data.result.items
			this.areaArr.forEach(item => {
				this.areaPermission += `,${item.name}`
			})
			this.areaPermission = this.areaPermission.slice(1)
		}
		this.getPurchaserVisitListData(1, this.search)
		// this.getAllDepart()
	},
	computed: {
		allPermission() {
			return this.$store.getters['session/hasRoles']('客户拜访所有权')
		},
		user() {
      return this.$store.state.session.user
		},
		editPermission() {
			if (this.$store.getters['session/hasRoles']('拜访表区域权限')) {
				return this.curVisitListData.am == this.$store.state.session.user.name
			} else {
				return true
			}
		}
	},
	methods: {
		// 获取所有部门
		// async getAllDepart() {
		// 	let rep = await axios.get(
		// 		requestUrls.purchaserInfo.getCompany
		// 	)
		// 	this.extraInfo.departArr = rep.data
		// },
		async getPurchaserVisitListData(page, search = {}) {
			this.pageNum = page;
			let filiale = search.filiale ? ` and filiale.Contains("${search.filiale}")` : ""
			let am = search.am ? ` and am.Contains("${search.am}")` : ""
			let clientNmae = search.clientNmae ? ` and clientNmae.Contains("${search.clientNmae}")` : ""
			let visitDate = search.startTime !== "" ? ` and visitDate >= "${formatDate(search.startTime)}" and visitDate <= "${formatDate(search.endTime)}"` : "";
			let querySear = filiale + am + clientNmae + visitDate
			querySear = querySear.slice(5)
			// 无所有权  权限限制
			if (!this.allPermission) {
				// 输入客户名称，可查询
				if (clientNmae) {
					querySear = filiale + am + clientNmae + visitDate
					querySear = querySear.slice(5)
				} else {
					if (this.$store.getters['session/hasRoles']('分公司负责人') || this.$store.getters['session/hasRoles']('拜访表区域权限')) {
						let arr = this.areaPermission.split(',')
						filiale = ''
						if (search.filiale == '') {
							arr.forEach(item => {
								filiale += ` or filiale.Contains("${item}")`
							})
						} else {
							filiale = ` or filiale.Contains("${search.filiale}")`
						}
						querySear = ` or (${filiale.slice(4)})` + am + clientNmae + visitDate
						querySear = querySear.slice(3)
					} else {
						am = ` and am.Contains("${this.user.name}")`
						querySear = filiale + am + clientNmae + visitDate
						querySear = querySear.slice(5)
					}
				}
			}
			ajax.get(requestUrls.CLCustomerVisit.getPurchaserVisitList,{
				params: {
					filter: querySear,
					maxResultCount: 10,
					skipCount: (this.pageNum - 1) * 10,
					sorting: 'visitDate desc'
				}
			}).then(req => {
				if (req.data.success) {
					// 数据加载成功 销毁 loading
					// this.$Message.destroy()
					var value = req.data.result.items;
					var list = value.map(current => {
						current.visitDate = formatDate(current.visitDate).substring(0, 10);
						return current;
					});
					this.purchaserVisitListData = list;
					this.pageTotal = (req.data.result.totalCount);
				}
			})
		},
		pageChange(pageNum) {
			this.getPurchaserVisitListData(pageNum, this.search)
		},
		viewVisitList(row) {
			this.curVisitListData = row;
			this.title = "查看拜访记录详细信息";
			this.addVisitListVisible = true;
			this.addStatus = 'false+' + new Date().getTime();
		},
		// 添加拜访记录
		addVisitList(value) {
			this.addVisitListVisible = true;
			this.title = "添加客户拜访记录";
			this.curVisitListData = value;
			this.addStatus = 'true+' + new Date().getTime();
		},
		// 添加成功后关闭Modal
		addOK: function (value) {
			this.addVisitListVisible = value;
			this.getPurchaserVisitListData(this.pageNum, this.search)
		},
		// 定义loading
		spinShow() {
			this.$Spin.show({
				render: (h) => {
					return h("div", {
						style: {
							position: 'relative',
							width: '100%',
							height: '100%',
							background: 'red'
						}
					}, [
							h("Icon", {
								props: {
									type: "load-c",
									size: 18,
								},
								style: {
									color: 'red',
									// background:'red'
								}
							}),
							h("div", { style: { color: 'red' } }, "加载中...")
						]);
				}
			});
		},
		searchResult() {
			this.getPurchaserVisitListData(1, this.search)
		}
	},
	watch: {

	}
}
</script>

<style lang="less" scoped>
.search-wrapper {
  margin: 0 0 10px;
}
.myspain {
  color: red;
  background: transparent;
}
</style>